import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/admin/opportunity/$opportunityId/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { opportunityId } = Route.useParams();
  return (
    <Navigate
      to="/admin/organizations/$organizationId/opportunities/$opportunityId"
      params={{
        organizationId: process.env.CONNECTED_ORGANIZATION_ID,
        opportunityId,
      }}
      replace
    />
  );
}
